import each from 'lodash/each'
import { store } from '../store/store'
import { ConfigManager } from '../services/ConfigManager'
import QPVRepository from '../repositories/QPV/QPVRepository'

class VideoClient {
  constructor() {
      this._adapted = new QPVRepository();
  }

  async get() {
    let result = {
      video: null,
      interactiveItems: [],
      slides: [],
      presentationMode: 'PIP'
    }
    result.video = await this.getVideoById(store.state.config)

    if (result.video.templateData) {
      this.setTemplateConfig(result.video.templateData);
    }

    if (store.state.config.audioOnly) {
      return result;
    }

    const slides = await this.getSlides();
    result.presentationMode = slides.presentationMode
    result.slides = slides.items
    result.video.chapters = await this.getChapters();
    result.interactiveItems = await this.getInteractiveArea()

    return result;
  }

  setTemplateConfig(templateConfig){
    var keysToOmit = store.state.dataset;
    var updatedConfig = ConfigManager.mergeTemplateConfig(templateConfig, keysToOmit, store.state.config)
    updatedConfig = Object.assign({}, store.state.config, updatedConfig)
    store.commit('changeConfig', updatedConfig)
  }
  /**
   * Returns a promise which should return a Video object on success
   * @param {*}id
   * @param {*}token
   * @returns {Promise}
   */
  getVideoById(id, token) {
    return this._adapted.getVideoById(id, token)
  }

  /**
   * Returns a promise which should return an array with Slide objects on success
   * @returns {Promise}
   */
  getSlides() {
    return this._adapted.getSlides()
  }

  /**
   * Returns a promise which should return a Chapters object on success
   * @returns {Promise}
   */
  getChapters() {
    return this._adapted.getChapters()
  }

  /**
   * Returns a promise which should return an array of InteractiveItems on success
   * @returns {Promise}
   */
  getInteractiveArea() {
    return this._adapted.getInteractiveArea()
  }
}

export default VideoClient
